import { useTranslation } from 'react-i18next';
import { logout as resetUserState } from 'src/redux/user/reducer';
import { PublicRoutes } from 'src/routes/navigation';
import useToast from 'src/context/ToastContext/ToastContext';
import { useIonRouter } from '@ionic/react';
import { useAuthFlow } from './useAuthFlow';

interface UseUpdateProfileResult {
  successfullyUpdatedProfile: (isGoBack?: boolean, isLogout?: boolean) => void;
}

export const useUpdateProfile = (): UseUpdateProfileResult => {
  const router = useIonRouter();
  const { t } = useTranslation('profile');
  const { showToast } = useToast();
  const { triggerSignOutFlow } = useAuthFlow();

  const successfullyUpdatedProfile = (isGoBack?: boolean, isLogout?: boolean) => {
    const DELAY = 3000;

    if (isGoBack) {
      router.goBack();
    }
    showToast({
      message: t(isLogout ? 'email_password_saved_tost' : 'changes_saved_tost'),
      durationMilliseconds: DELAY,
    });
    if (isLogout) {
      const logoutTimer = setTimeout(async () => {
        clearTimeout(logoutTimer);
        resetUserState();
        await triggerSignOutFlow();
        router.push(PublicRoutes.AUTH, 'root', 'replace');
      }, DELAY);
    }
  };

  return {
    successfullyUpdatedProfile,
  };
};
